import axios from "axios";
import { getApiErrorMessage } from "./phoneApi";

export const sendReminder = async (accessToken, payload) => {
  const response = await axios.post("/api/phone/reminder-call", payload, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response.data;
};

export const getReminderStatus = (data) => {
  const voice = data?.voice;
  const sms = data?.sms;
  const voiceOk = Boolean(voice?.ok);
  const smsOk = Boolean(sms?.ok);
  const voiceAttempted = Boolean(voice?.attempted);
  const smsAttempted = Boolean(sms?.attempted);

  if (voiceOk && smsOk) {
    return { kind: "success", message: "Voice queued; SMS sent" };
  }

  if (voiceOk && smsAttempted && !smsOk) {
    return { kind: "warning", message: "Voice queued; SMS not confirmed" };
  }

  if (smsOk && voiceAttempted && !voiceOk) {
    return { kind: "warning", message: "SMS sent; voice not confirmed" };
  }

  if (voiceOk) {
    return { kind: "success", message: "Voice reminder queued" };
  }

  if (smsOk) {
    return { kind: "success", message: "SMS reminder sent" };
  }

  if (data?.reminderId) {
    return { kind: "success", message: "Reminder queued" };
  }

  return { kind: "success", message: "Reminder sent" };
};

export { getApiErrorMessage };
